/**
 * <prelaunch-loading-form> — shows a loading state on the submit button of
 * the form it wraps (signup / access code on the pre-launch page).
 *
 * On submit: the button gets the `loading` class (label fades out), its
 * .loading__spinner is revealed, and the button is disabled one frame later
 * — after the browser has built the form data — so double-clicks can't
 * re-submit. The submit event doesn't fire when native validation fails, so
 * the spinner never shows on an invalid form. `pageshow` with `persisted`
 * resets the state when the page is restored from the back/forward cache.
 */
class PrelaunchLoadingForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.addEventListener('submit', () => this.setLoading(true));
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) this.setLoading(false);
    });
  }

  setLoading(isLoading) {
    const button = this.form.querySelector('button[type="submit"], [name="commit"]');
    if (!button) return;

    const spinner = button.querySelector('.loading__spinner');

    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    spinner?.classList.toggle('hidden', !isLoading);

    if (isLoading) {
      requestAnimationFrame(() => {
        button.disabled = true;
      });
    } else {
      button.disabled = false;
    }
  }
}

if (!customElements.get('prelaunch-loading-form')) {
  customElements.define('prelaunch-loading-form', PrelaunchLoadingForm);
}
